
import { defineComponent } from 'vue';
import * as localisation from '../helpers/localise-number';

export default defineComponent({
  name: 'BaseEmphasis',

  props: {
    label: {
      type: String,
      default: undefined
    },
    value: {
      type: [String, Number, Array],
      default: undefined
    },
    valueString: {
      type: String,
      default: undefined
    },
    unit: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'column',
      validator: (value: string) => {
        return ['column', 'row'].includes(value);
      }
    },
    spaceBetween: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: (value: string) => {
        return ['sm', 'md', 'lg'].includes(value);
      }
    }
  },

  data() {
    return {
      number: '',
      punctuation: '',
      decimal: ''
    };
  },

  computed: {
    isRow(): boolean {
      return this.direction === 'row';
    },

    isSmall(): boolean {
      return this.size === 'sm';
    },

    showValue(): boolean {
      return (this.value || this.value === 0) && !this.valueString;
    },

    showUnit(): boolean {
      return this.showValue && !!this.unit;
    },

    valueIsZero(): boolean {
      const value = this.value.toString().split('.');
      const numberIsZero = Number(value[0]) === 0;
      const decimalIsZero = Number(value[1]) === 0;
      return numberIsZero && decimalIsZero;
    }
  },

  watch: {
    value() {
      this.formatValue();
    }
  },

  created() {
    this.formatValue();
  },

  methods: {
    getClassFor(feature: string, size: string): string {
      const featureSize = feature + size;
      const getUtilityClass: Record<string, string> = {
        labelsm: 'sm',
        valuesm: 'md',
        decimalsm: 'md',
        unitsm: 'sm',
        labelmd: 'sm',
        valuemd: '4xl',
        decimalmd: '2xl',
        unitmd: 'sm',
        labellg: 'md',
        valuelg: '6xl',
        decimallg: '5xl',
        unitlg: 'md'
      };

      const mixin = getUtilityClass[featureSize];

      return `base-emphasis__${feature} u-font-${mixin}`;
    },

    formatValue(): void {
      if (this.value === null || this.value === undefined) {
        return;
      }
      this.number = localisation.localisedNumber(this.value);
      if (!this.valueIsZero) {
        this.punctuation = localisation.localisedPunctuation(this.value);
        const decimalAsNumber = Number(this.value.toString().split('.')[1]);
        const getDecimal = this.value.toString().split('.')[1];
        const decimals = [];
        if (getDecimal) {
          for (const decimal of getDecimal) {
            const localisedDecimals = localisation.localisedNumber(decimal);
            decimals.push(localisedDecimals);
          }
        }
        this.decimal = decimalAsNumber === 0 ? '' : decimals.join('');
      }
    }
  }
});
